// theme/muiTheme.ts
import { createTheme } from '@mui/material/styles';

const HEIGHTS = {
    small: 28,
    medium: 32,
    large: 40
};

export const muiTheme = createTheme({
    typography: {
        fontSize: 14,
        // 👉 Đổi Roboto thành Inter
        fontFamily: '"Inter", system-ui, -apple-system, "Segoe UI", sans-serif'
    },
    palette: {
        primary: {
            main: '#1976d2'
        },
        secondary: {
            main: '#328C99'
        }
    },
    components: {
        // Đảm bảo body cũng dùng Inter theo theme
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontFamily: '"Inter", system-ui, -apple-system, "Segoe UI", sans-serif'
                }
            }
        },

        MuiTextField: {
            defaultProps: {
                variant: 'outlined',
                size: 'medium',
                fullWidth: true,
                sx: {
                    minHeight: HEIGHTS.medium
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    backgroundColor: '#fff',
                    minHeight: HEIGHTS.medium,
                    padding: 0,
                    display: 'flex',
                    alignItems: 'center',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'var(--primary)'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'var(--primary)',
                        borderWidth: 2
                    },
                    '&.MuiInputBase-multiline': {
                        height: 'auto'
                    },
                    '& .MuiChip-root': {
                        height: HEIGHTS.medium - 6,
                        fontSize: '0.75rem',
                        borderRadius: 6,
                        margin: 2
                    }
                },
                input: {
                    padding: '4px 12px',
                    fontSize: '0.875rem',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    lineHeight: 1.5
                },
                notchedOutline: {
                    borderColor: '#d0d7de'
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '0.8rem',
                    fontWeight: 500,
                    color: '#4b5563'
                }
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: '0.75rem'
                }
            }
        },
        MuiButton: {
            defaultProps: {
                size: 'medium',
                variant: 'contained'
            },
            styleOverrides: {
                root: {
                    borderRadius: 6,
                    minHeight: HEIGHTS.medium,
                    padding: '6px 12px',
                    fontSize: '0.875rem',
                    textTransform: 'none'
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    minHeight: HEIGHTS.medium,
                    '.MuiOutlinedInput-root': {
                        paddingRight: '34px !important'
                    }
                },
                inputRoot: {
                    padding: '0 !important',
                    minHeight: HEIGHTS.medium,
                    alignItems: 'center',
                    '& .MuiAutocomplete-input': {
                        padding: '0px 12px',
                        lineHeight: 1.5
                    }
                },
                tag: {
                    height: HEIGHTS.small,
                    fontSize: '0.75rem',
                    borderRadius: 6,
                    margin: 2,
                    maxWidth: 120,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                },
                popupIndicator: {
                    top: 'calc(50% - 14px)'
                },
                clearIndicator: {
                    top: 'calc(50% - 14px)'
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 6,
                    fontSize: '0.75rem',
                    maxWidth: 120,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                },
                label: {
                    paddingLeft: 6,
                    paddingRight: 6
                }
            }
        }
    }
});
